// src/pages/HaberYonetim.js

import React, { useState, useEffect } from 'react';
import { callApi, callPublicApi } from '../api';
import HaberFormu from '../components/HaberFormu';
import './YonetimSayfasi.css';
import { Edit3, Trash2, ImageOff, Plus } from 'lucide-react';

const HaberYonetim = ({ kulup }) => {
    const [haberler, setHaberler] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [haberToEdit, setHaberToEdit] = useState(null);

    useEffect(() => {
        fetchHaberler();
    }, [kulup]);

    const formatDate = (dateString) => {
        if (!dateString) return 'Belirtilmemiş';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) { return 'Geçersiz Tarih'; }
        return date.toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    };

    const fetchHaberler = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const data = await callPublicApi('/haberler');

            let parsedBody = [];

            if (data && data.body) {
                const bodyParse = JSON.parse(data.body);
                parsedBody = bodyParse.items ? bodyParse.items : bodyParse;
            } else if (data && data.items) {
                parsedBody = data.items;
            } else if (Array.isArray(data)) {
                parsedBody = data;
            } else {
                console.error("HATA TESPİTİ: Haberler API'si boş veya hatalı formatta yanıt döndürdü.", data);
                setError("Haberler yüklenemedi. Sunucu formatı uyumsuzluğu.");
                setIsLoading(false);
                return;
            }

            let haberItems = Array.isArray(parsedBody) ? parsedBody : parsedBody.items || [];

            // KULÜP FILTRELEME
            if (kulup) {
                haberItems = haberItems.filter(item => {
                    if (kulup.kulupID === 'klugastro' || !kulup.kulupID) {
                        return !item.kulupID || item.kulupID === 'klugastro';
                    }
                    return item.kulupID === kulup.kulupID;
                });
            }

            haberItems.sort((a, b) => new Date(b.olusturmaTarihi) - new Date(a.olusturmaTarihi));

            setHaberler(haberItems);
        } catch (err) {
            console.error("Haber yükleme hatası:", err);
            setError(err.message || "Haberler yüklenemedi. Sunucu formatı uyumsuzluğu.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (haberID) => {
        if (!window.confirm("Bu haberi silmek istediğinizden emin misiniz?")) { return; }
        setIsLoading(true);
        setError(null);
        try {
            await callApi(`/haberler?haberID=${haberID}`, 'DELETE');
            fetchHaberler();
        } catch (err) {
            setError(err.message || "Haber silme işlemi başarısız oldu.");
            setIsLoading(false);
        }
    };

    const handleEdit = (haber) => {
        setHaberToEdit(haber);
        setIsFormOpen(true);
    };

    const handleFormSave = () => {
        setIsFormOpen(false);
        setHaberToEdit(null);
        fetchHaberler();
    };

    if (isLoading && haberler.length === 0 && !error) return <div className="loading-state">Haberler Yükleniyor...</div>;

    return (
        <div className="yonetim-sayfasi">
            <h2>Haber Yönetimi {kulup ? `(${kulup.ad})` : ''}</h2>
            
            {error && <div className="error-message">{error}</div>}
            
            <button className="primary-button" onClick={() => { setHaberToEdit(null); setIsFormOpen(true); }} style={{ marginBottom: '20px' }}>
                <Plus size={18} /> Yeni Haber Ekle
            </button>

            {/* Haber Ekleme/Düzenleme Formu Modal'ı */}
            {isFormOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <HaberFormu
                            haberToEdit={haberToEdit}
                            kulup={kulup}
                            onSave={handleFormSave}
                            onCancel={() => setIsFormOpen(false)}
                        />
                    </div>
                </div>
            )}

            {/* Haber Listesi — Card-Based (Mobil Uyumlu) */}
            <div className="admin-card-grid">
                {haberler.length > 0 ? (
                    haberler.map((haber) => (
                        <div key={haber.haberID} className="admin-card">
                            {/* Üst Görsel */}
                            <div className="admin-card-image">
                                {(haber.resimURL || haber.resimUrl) ? (
                                    <img src={haber.resimURL || haber.resimUrl} alt="Haber" />
                                ) : (
                                    <div className="admin-card-image-placeholder">
                                        <ImageOff size={28} />
                                    </div>
                                )}
                            </div>

                            {/* İçerik */}
                            <div className="admin-card-body">
                                <h4 className="admin-card-title">{haber.baslik}</h4>
                                <span className="admin-card-meta">
                                    📅 {formatDate(haber.olusturmaTarihi)}
                                </span>
                                {haber.aciklama && (
                                    <p className="admin-card-desc">{haber.aciklama.substring(0, 80)}{haber.aciklama.length > 80 ? '...' : ''}</p>
                                )}
                            </div>

                            {/* Aksiyonlar */}
                            <div className="admin-card-actions">
                                <button onClick={() => handleEdit(haber)} className="admin-action-btn admin-action-edit" title="Düzenle">
                                    <Edit3 size={16} /> Düzenle
                                </button>
                                <button onClick={() => handleDelete(haber.haberID)} className="admin-action-btn admin-action-delete" title="Sil">
                                    <Trash2 size={16} /> Sil
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="admin-card-empty">
                        Henüz eklenmiş haber bulunmamaktadır.
                    </div>
                )}
            </div>
        </div>
    );
};

export default HaberYonetim;